module.exports = __webpack_public_path__ + "static/media/driver_photo_placeholder.a627652d.svg";